<template>
  <section>
    <el-form :model="formObj" :rules="formRules" ref="formObj" label-width="120px">
      <el-form-item label="项目" prop="proId">
        <el-select v-model="formObj.proId" placeholder="请选择项目">
          <el-option v-for="(item,index) in GLOBAL.proList" :key="index" :value="item.id" :label="item.proName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标题" prop="dataName">
        <el-input v-model="formObj.dataName" placeholder="请输入标题" maxlength="20"  show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="dataDesc" v-if="showDataType">
        <el-select v-model="formObj.dataDesc">
          <el-option v-for="(item,index) in dataDescList" :key="index" :value="item.id" :label="item.type"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="上传附件" prop="dataPath">
        <el-upload
          class="upload-demo"
          :action="this.GLOBAL.baseServerPath+'/fileupload'"
          :headers="this.GLOBAL.fileHeader"
          name="file"
          :file-list="fileList"
          :limit="1"
          :on-exceed="handleExceed"
          :on-remove="removeConUpload"
          :on-success="successConUpload">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip"></div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="doCancel">取消</el-button>
      <el-button type="primary" @click.native="doSubmit(option)">确定</el-button>
    </div>
  </section>
</template>

<script>
  import {dataCreate, dataUpdate} from '../../api/api'
  export default {
    name: "EnclosureDataForm",
    props: {
      option: 0,
      formData: {},
      type: 0,
      showDataType:false,
    },
    data() {
      return {
        fileList: [],
        formObj: { proId :null,dataPath:null},
        formRules: {
          proId: [
            {required: true, message: '请选择项目', trigger: 'change'}
          ],
          dataName: [
            { required: true, message: '请输入标题', trigger: 'blur' }
          ],
          dataDesc: [
            { required: true, message: '请选择类型', trigger: 'change' }
          ],
          dataPath: [
            { required: true, message: '请上传附件'}
          ]
        },
        dataDescList:[{id:1,type:'建筑'},{id:2,type:'结构'},{id:3,type:'给排水'},{id:4,type:'暖通'},{id:5,type:'电气'}],
      }
    },
    methods: {
      doSubmit: function (option) {
        this.formObj.dataType = this.type;
        this.$refs.formObj.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
              if (option == 0) {
                dataCreate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "添加成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              } else if (option == 1) {
                dataUpdate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "修改成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              }
            }).catch(() => {
            });
          }
        });
      },
      doCancel: function () {
        this.$emit('doCancel');
      },
      successConUpload: function (response) {
        this.formObj.dataPath = response.data;
        this.$refs.formObj.validate();
      },
      removeConUpload: function () {
        this.formObj.dataPath = null;
      },
      //上传限制
      handleExceed: function (files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
    },
    mounted() {
      //初始化表单数据
      if (this.option == 1) {
        this.formObj = this.formData;
        this.formObj.dataDesc = parseInt(this.formObj.dataDesc)
        if (this.formObj.dataPath != null && this.formObj.dataPath != '') {
          this.fileList.push({url: this.GLOBAL.basePhotoPath + '' + this.formObj.dataPath})
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/command/EncDataForm.vue